type PaginationBarProps = {
  page: number;
  limit: number;
  total: number;
  totalPages?: number;
  itemLabel?: string;
  onPageChange: (page: number) => void;
  onLimitChange: (limit: number) => void;
};

export const PAGE_SIZE_OPTIONS = [10, 25, 50];

export const slicePage = <T,>(rows: T[], page: number, limit: number) => {
  const total = rows.length;
  const totalPages = Math.max(1, Math.ceil(total / limit) || 1);
  const safePage = Math.min(Math.max(page, 1), totalPages);

  return {
    rows: rows.slice((safePage - 1) * limit, safePage * limit),
    page: safePage,
    total,
    totalPages,
  };
};

const PaginationBar = ({
  page,
  limit,
  total,
  totalPages,
  itemLabel = "entries",
  onPageChange,
  onLimitChange,
}: PaginationBarProps) => {
  const pages = Math.max(1, totalPages || Math.ceil(total / limit) || 1);
  const start = total ? (page - 1) * limit + 1 : 0;
  const end = Math.min(page * limit, total);

  return (
    <div className="pagination">
      <span>
        Showing {start} to {end} of {total} {itemLabel}
      </span>
      <div>
        <button type="button" disabled={page <= 1} onClick={() => onPageChange(page - 1)}>
          ‹
        </button>
        <strong>{page}</strong>
        <button type="button" disabled={page >= pages} onClick={() => onPageChange(page + 1)}>
          ›
        </button>
        <select
          value={limit}
          onChange={(event) => onLimitChange(Number(event.target.value))}
        >
          {PAGE_SIZE_OPTIONS.map((size) => (
            <option key={size} value={size}>
              {size} / page
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default PaginationBar;
